export const AVATAR_MAX_SIZE = 30 * 1000 * 1000;
